"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgDeactivatedNotice = void 0;
const Flex_1 = __importStar(require("@targetx/mineral-ui/Flex"));
const Text_1 = __importDefault(require("@targetx/mineral-ui/Text"));
const palette_1 = __importDefault(require("@targetx/mineral-ui/themes/generated/palette"));
const IconTimes_1 = __importDefault(require("@targetx/tx-web-ui-lib/lib/icons/IconTimes"));
const react_1 = __importDefault(require("react"));
const theme_1 = __importDefault(require("../../theme"));
const OrgDeactivatedNotice_copyText_1 = __importDefault(require("./OrgDeactivatedNotice.copyText"));
function OrgDeactivatedNotice() {
    return (react_1.default.createElement(Flex_1.default, { alignItems: "center", direction: "column", height: "100%", paddingTop: "8em", width: "100%" },
        react_1.default.createElement(IconTimes_1.default, { size: 120, color: palette_1.default.red[60] }),
        react_1.default.createElement(Flex_1.FlexItem, { grow: 1, marginTop: theme_1.default.space_stack_lg, paddingHorizontal: theme_1.default.space_inline_xl },
            react_1.default.createElement(Text_1.default, { as: "h1", align: "center", bold: true, color: palette_1.default.gray[90], fontSize: "1.5rem", marginBottom: theme_1.default.space_stack_sm }, OrgDeactivatedNotice_copyText_1.default.header),
            react_1.default.createElement(Text_1.default, { align: "center", fontSize: theme_1.default.fontSize_base }, OrgDeactivatedNotice_copyText_1.default.body))));
}
exports.OrgDeactivatedNotice = OrgDeactivatedNotice;
exports.default = OrgDeactivatedNotice;
